/** Official AURALUX brand themes — four themes, one identity. */
export const THEMES = [
  {
    id: 'navy-authority',
    label: 'Navy Authority',
    swatch: '#1E2D4B',
    themeColor: '#1E2D4B',
    toast: 'dark',
    description: 'Flagship corporate look',
  },
  {
    id: 'precision-light',
    label: 'Precision Light',
    swatch: '#496CB1',
    themeColor: '#F5F6F8',
    toast: 'light',
    lightSwatch: true,
    description: 'Technical content & R&D',
  },
  {
    id: 'sustainability',
    label: 'Sustainability',
    swatch: '#2D8C57',
    themeColor: '#2D8C57',
    toast: 'dark',
    description: 'ESG & circularity',
  },
  {
    id: 'signature-gold',
    label: 'Signature Gold',
    swatch: '#D5B036',
    themeColor: '#D5B036',
    toast: 'dark',
    description: 'Executive & launch',
  },
];

export const DEFAULT_THEME_ID = 'precision-light';

export const THEME_BY_ID = Object.fromEntries(THEMES.map((t) => [t.id, t]));

export const STORAGE_KEY = 'auralux-portal-theme';
